import { getConfiguration } from '../config/configuration';
import {
  Topic, Topics, TopicSyncRequestState, TopicSyncState, Term,
} from '../store/topics/types';
import { httpDelete, httpGet, httpPost } from './httpClient';

export class TopicApi {
  constructor() {
    const appConfig = getConfiguration();
    this.baseUrl = appConfig.adminApiBaseUrl;
  }

  private baseUrl : string;

  public getTopics = () : any => httpGet<Topics>(`${this.baseUrl}/api/topics`);

  public createTopic = (topic: Topic) : any => httpPost<Topic, Topic>(`${this.baseUrl}/api/CreateTopic`, topic);

  public updateTopic = (topic: Topic) : any => httpPost<Topic, Topic>(`${this.baseUrl}/api/UpdateTopic`, topic);

  public deleteTopic = (topic: Topic) : any => httpDelete(`${this.baseUrl}/api/topics/${topic.topicId}`);

  public getSynonyms = () : any => httpGet<Topics>(`${this.baseUrl}/api/synonyms`);

  public getAntonyms = () : any => httpGet<Topics>(`${this.baseUrl}/api/antonyms`);

  public pollSyncStatus = (): any => httpGet<TopicSyncState>(`${this.baseUrl}/api/topicsyncinfo`);

  public syncTopics = (): any => httpGet<TopicSyncRequestState>(`${this.baseUrl}/api/synctopics`);

  public createSynonym = (term: Term): any => httpPost<Term, Term>(`${this.baseUrl}/api/CreateSynonym`, term);

  public createAntonym = (term: Term): any => httpPost<Term, Term>(`${this.baseUrl}/api/CreateAntonym`, term);
}
